@if (visible) {
	@if (v2) {
		<div class="documentation-v2">
			@if (documentation.manuals.length > 0) {
				<button
					type="button"
					class="documentation-v2-action"
					(click)="manuals()"
					[attr.aria-label]="'CHECKLISTS__DOCUMENTATION__SELECT_MANUAL' | transloco"
				>
					<span class="material-symbols-outlined" aria-hidden="true">description</span>
				</button>
			}
			@if (documentation.videos.length > 0) {
				<button
					type="button"
					class="documentation-v2-action"
					(click)="videos()"
					[attr.aria-label]="'CHECKLISTS__DOCUMENTATION__SELECT_VIDEO' | transloco"
				>
					<span class="material-symbols-outlined" aria-hidden="true">movie</span>
				</button>
			}
			@if (documentation.links.length > 0) {
				<button
					type="button"
					class="documentation-v2-action"
					(click)="links()"
					[attr.aria-label]="'CHECKLISTS__DOCUMENTATION__SELECT_LINK' | transloco"
				>
					<span class="material-symbols-outlined" aria-hidden="true">link</span>
				</button>
			}
		</div>
	} @else {
		<ion-toolbar>
			<ion-buttons slot="end">
				<ion-button *ngIf="documentation.manuals.length > 0" (click)="manuals()">
					<ion-icon slot="icon-only" name="document-text-outline"></ion-icon>
				</ion-button>
				<ion-button *ngIf="documentation.videos.length > 0" (click)="videos()">
					<ion-icon slot="icon-only" name="film-outline"></ion-icon>
				</ion-button>
				<ion-button *ngIf="documentation.links.length > 0" (click)="links()">
					<ion-icon slot="icon-only" name="link-outline"></ion-icon>
				</ion-button>
			</ion-buttons>
		</ion-toolbar>
	}
}
